//@ts-ignore
import watch from 'redux-watch'
import * as Reducers from './reducers/index'
import * as Actions from './actions/actions'
import { sendRequest } from '@alme/ui-web/modules/lib-alme-request/src/lib-alme-request';
import { AlmeState } from '@alme/ui-web/wireup/AlmeState';
import { Store } from 'redux';
import { AlightCustomSettingsType } from '../../settings/alight-custom-settings';
import { Input } from '@alme/ui-web/types/input';

export default class ModuleAdvocacy {
    _settings: AlightCustomSettingsType;
    _store: Store<AlmeState> | undefined;
    _initializationPromises: any;

    constructor(settings: AlightCustomSettingsType) {
        this._settings = settings;   
    }

    getReducer() {
        return Reducers.reducer;
    }

    initialize(store: Store<AlmeState>, initPromise: any) {
        this._store = store;
        this._initializationPromises = initPromise;

        let advocacyFunction = this._settings.advocacySettings.advocacyDataFunctionName;
        let launchPointName = this._settings.classNames.launchPoint;

        let windowBase = this._settings.stateLocations.Window.Base;
        let lastLaunchedLocation = this._settings.stateLocations.Window.urlLastLaunchedFrom;
        let launchedProactivelyBase = this._settings.stateLocations.Window.advocacyVariables.Base;
        let launchedProactivelyFlag = this._settings.stateLocations.Window.advocacyVariables.launchedProactively;
        let productPayloadBase = this._settings.stateLocations.Window.productPayload.Base;
        
        //  create function Upoint can call to launch proactively
        window.advocacyProactiveLaunch = () => {
            //  bail if we already launched on this page - only matters if we launched here without navigating away (during 3 seconds)
            let currentUrl = document.location.href;
            //@ts-ignore
            if (currentUrl === (this._store.getState()[windowBase][lastLaunchedLocation])){
                return;
            }

            let launchPoint = document.getElementsByClassName(launchPointName);

            //  check if launch point exists yet, retry in 100 ms
            if (launchPoint.length < 1) {
                //@ts-ignore
                setTimeout(() => { window[advocacyFunction](); }, 100);
                return;
            }

            //  set flag that lets renderer know we've launched proactively
            this._store?.dispatch(Actions.setLaunchProctiveFlag(`${windowBase}.${launchedProactivelyBase}.${launchedProactivelyFlag}`, true));
            //  launch
            //@ts-ignore
            launchPoint[0].click();
        }   //  end window.advocacyProactiveLaunch

         // watch for isMinimized state and call handleProactiveMessaging if being launched outside of upoint proactive launch
        let minimizedStateLocation = `${this._settings.stateLocations.Window.Base}.${this._settings.stateLocations.Window.IsMinimized}`;
        let launchWatcher = watch(this._store.getState, minimizedStateLocation);
        
        this._store.subscribe(launchWatcher((newVal: any, oldVal: any, objectPath: any) => {
            if(!newVal){
                //check if product payload has been saved
                //@ts-ignore
                if (!this._store.getState()[windowBase][productPayloadBase]/*[productSavedLocation]*/) {
                    //  bail if not saved - ie this is a welcome user event
                    return;
                }
                return this.handleProactiveMessaging();

            }
        })); 

        this.handleWelcomeUser();
       
    }   //  end initialize

    async handleWelcomeUser(){
        await this._initializationPromises.onLaunch;

        let advocacyPageFromWelcomeUser = this.getAdvocacyPageIfOnEligiblePage();
        if(advocacyPageFromWelcomeUser === null){
            return;
        }

        let windowBase = this._settings.stateLocations.Window.Base;
        let launchedProactivelyBase = this._settings.stateLocations.Window.advocacyVariables.Base;
        let messagesGivenBase = this._settings.stateLocations.Window.advocacyVariables.messagesGiven.Base;
        this._store?.dispatch(Actions.setAdvocacyMessageDelivered(`${windowBase}.${launchedProactivelyBase}.${messagesGivenBase}.${advocacyPageFromWelcomeUser}`, true));
    }

    async handleProactiveMessaging(){
        await this._initializationPromises.onLoad;

        let launchedProactivelyBase = this._settings.stateLocations.Window.advocacyVariables.Base;
        let messagesGivenBase = this._settings.stateLocations.Window.advocacyVariables.messagesGiven.Base;

        let windowBase = this._settings.stateLocations.Window.Base;
        let isMinimized = this._settings.stateLocations.Window.IsMinimized;

        // Only need to check to see if the messages have already been given if the window is already open....
        //@ts-ignore
        let windowIsMinimized = this._store.getState()[windowBase][isMinimized];
        // only do the following if the IVA is open
        if (!windowIsMinimized) {
            // await this._initializationPromises.onLaunch;

            //  check the messagesGiven section here to determine whether we need to proactively message
            //@ts-ignore
            let whichMessagesWereGiven = this._store.getState()[windowBase][launchedProactivelyBase][messagesGivenBase];

            let advocacyPage = this.getAdvocacyPageIfOnEligiblePage();

            if(advocacyPage === null || whichMessagesWereGiven[advocacyPage]){
                return;
            }

            let input = {
                messageType: this._settings.messageConstants.appeventRequest,
                eventName: this._settings.appeventConstants.advocacyProactiveMessageName,
                origin: this._settings.originConstants.internal
            }

            await this._initializationPromises.onLaunch;
            sendRequest(input as Input);

            //  set message given flag
            this._store?.dispatch(Actions.setAdvocacyMessageDelivered(`${windowBase}.${launchedProactivelyBase}.${messagesGivenBase}.${advocacyPage}`, true))
        }

    }

    getAdvocacyPageIfOnEligiblePage(){
        try{
            let advocacyPages = [];
            let windowBase = this._settings.stateLocations.Window.Base;
            let advocacyBase = this._settings.stateLocations.Window.advocacyVariables.Base;
            let advocacyConfigLocation = this._settings.stateLocations.Window.advocacyVariables.advocacyConfigData;
            
            //@ts-ignore
            if (this._store?.getState()[windowBase][advocacyBase][advocacyConfigLocation] !== undefined) {
                //@ts-ignore
                advocacyPages = this._store?.getState()[windowBase][advocacyBase][advocacyConfigLocation];
            }

            if(advocacyPages.length < 1){
                return null;
            }

            let currentUrl = document.location.href;
            let eligiblePagePath = advocacyPages[this._settings.advocacySettings.eligiblePageListName]
            if(eligiblePagePath !== undefined && eligiblePagePath !== null){
                if(currentUrl.indexOf(eligiblePagePath) > -1){
                    for(let advocacyPage in advocacyPages) {
                        if(advocacyPage !== this._settings.advocacySettings.eligiblePageListName && 
                            currentUrl.indexOf(advocacyPages[advocacyPage]) > -1){
                                return advocacyPage;
                        }
                    }
                }
            }
            else{
                for(let advocacyPage in advocacyPages) {
                    if(advocacyPage !== this._settings.advocacySettings.eligiblePageListName && 
                        currentUrl.indexOf(advocacyPages[advocacyPage]) > -1){
                            return advocacyPage;
                    }
                }
            }

            return null;
        }
        catch{
            return null;
        }
    }
}



// WEBPACK FOOTER //
// ./modules/advocacy/advocacy.ts